import React from 'react';
import { Button } from '@getsynapse/design-system';
import intl from 'react-intl-universal';
import exportIcon from 'assets/icons/export-square.svg';
import { showNotification } from 'state/SnackbarNotification/SnackbarNotificationSlice';
import { useDispatch } from 'react-redux';

const DrillTableHeaderFilters: React.FC<{
  title?: string;
  exportEnabled?: boolean;
  onExportClick: () => void;
}> = ({ title, exportEnabled = false, onExportClick }) => {
  const dispatch = useDispatch();

  const handleExportClick = () => {
    try {
      onExportClick();
    } catch (error) {
      dispatch(
        showNotification({
          notificationVariant: 'error',
          notificationTitle: intl.get(
            'DASHBOARD_DETAIL.ACTION.EXPORT_ERROR_TITLE'
          ),
          notificationMessage: intl.get(
            'DASHBOARD_DETAIL.ACTION.EXPORT_ERROR_MESSAGE'
          ),
        })
      );
    }
  };

  return (
    <div>
      <div className='flex justify-between mb-5'>
        <h2 className='text-xl font-bold'>
          {title || intl.get('DASHBOARD_DETAIL_PAGE.DRILLDOWN_DATA')}
        </h2>
        <Button
          size='small'
          variant='secondary'
          iconSrc={exportIcon}
          disabled={!exportEnabled}
          onClick={handleExportClick}
        >
          {intl.get('DASHBOARD_DETAIL.ACTION.EXPORT_DATA')}
        </Button>
      </div>
    </div>
  );
};

export default DrillTableHeaderFilters;
